module.exports = __webpack_public_path__ + "static/media/bid.6bc241f2.png";